import styled from 'styled-components';

export const FeedDetailFooterBlock = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 calc(100vw * (20 / 375)) calc(100vw * (10 / 375)) calc(100vw * (20 / 375));
`;

export const CommentCountNumArea = styled.div`
    padding-bottom: calc(100vw * (5 / 375));
    width: 100%;
`;

export const CommentCountNumText = styled.span`
    font-size: calc(100vw * (12 / 375));
    color: #989898;
`;

export const FeedCommentContent = styled.ul`
    padding-bottom: calc(100vw * (10 / 375));
`;

export const CommentMoreButtonBlock = styled.div`
    display: flex;
    align-items: center;
`;

export const CommentMoreButton = styled.button`
    font-size: calc(100vw * (12 /375));
    color: #989898;
`;

export const ArrowDownIconArea = styled.div`
    display: flex;
    align-items: center;
    margin-left: calc(100vw * (5 / 375));
`;

export const ArrowDownIcon = styled.img`
    object-fit: cover;
`;

export const InputBarOpenButton = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

export const ProfileImageArea = styled.div`
    width: calc(100vw * (23 / 375));
    height: calc(100vw * (23 / 375));   
    border-radius: 50%;
    overflow: hidden;
    border: solid calc(100vw * (1 / 375)) #c6c6c6;
`;

export const CurrentUserProfileImg = styled.img`
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
`;

export const Text = styled.p`
    width: 90%;
    font-size: calc(100vw * (14 / 375));
    padding-left: calc(100vw * (8 / 375));
    color: #989898;
`;

export const FeedDescriptionBlock = styled.div`
    width: 100%;
    margin-bottom: calc(100vw * (11 / 375));
`;

export const FeedDescription = styled.span`
    font-size: calc(100vw * (14 / 375));
    font-weight: 400;
    line-height: calc(100vw * (20.27 / 375));
    white-space: pre-wrap;
    word-break: break-all;
`;

export const ShowMoreBtn = styled.button`
    font-size: calc(100vw * (12 / 375));
    color: #7f7f7f;
`;